import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { makeSelectSprayEventForSubmissionCropSureDetails } from 'services/sprayEventsForSubmission/selectors';

const selectParentEntityNames = createDeepEqualSelector(
    makeSelectSprayEventForSubmissionCropSureDetails(),
    (cropSureDetails) =>
        cropSureDetails &&
        cropSureDetails.blocks &&
        cropSureDetails.blocks.length ?
            cropSureDetails.blocks.map(({ block_code, subdivision_code }) => `${block_code}/${subdivision_code}`)
            .sort()
            .join(', ') :
            ''
);

const makeSelectParentEntityNames = (): typeof selectParentEntityNames => selectParentEntityNames;

export { makeSelectParentEntityNames };
